/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import { yellow } from '@ant-design/colors';
import {
  CheckCircleFilled,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  LeftOutlined,
  RightOutlined,
  StarFilled
} from '@ant-design/icons';
import {
  Button,
  Carousel,
  Col,
  Grid,
  Radio,
  Row,
  Space,
  Tooltip,
  Typography
} from 'antd';
import React, {
  Fragment,
  useContext,
  useLayoutEffect,
  useRef,
  useState
} from 'react';
import styled from 'styled-components';
import { CONFIG, USER_STATES } from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import UserContext from '../../context/user-context';
import addScrollShadows from '../../scroll-util';
import {
  getCarouselData,
  getTable,
  getTableOpcionesPago,
  hexToRgb
} from '../../utils';
import { formatoMonedaGenerico } from '../../utils/converters';

const { useBreakpoint } = Grid;
const backgroundColor = () => '#fafafa';
// const backgroundColor = () => CONFIG.COLOR_PRIMARY;
const backgroundColorMobile = '#fafafa';
const disabledBackgroundColorHeader = () => '#f0f0f0';
// const disabledBackgroundColorHeader = () =>
//   `rgb(${hexToRgb(CONFIG.COLOR_PRIMARY)}, 0.75)`;
const disabledBackgroundColor = '#f0f0f0';
const disabledTextColor = 'grey';
const border = '#f0f0f0';
// const borderHeader = () => CONFIG.COLOR_PRIMARY;
const borderHeader = () => border;

const Container = styled.div`
  border: ${() => `1px solid ${border}`};
  ${(props) =>
    (props.isSelector || props.isMobile) &&
    (props.selected
      ? `border: 2px solid ${CONFIG.COLOR_PRIMARY}`
      : `border: 2px solid ${border}`)};
  border-radius: 6px;
  overflow: auto;
  ${(props) =>
    !props.isMobile && props.hover
      ? `&:hover {
    border: 2px solid ${CONFIG.COLOR_PRIMARY};
    overflow: auto;
  }`
      : ``};
`;

const CustomCarousel = styled(Carousel)`
  background: ${() => backgroundColorMobile};
  .slick-list > .slick-track {
    border-bottom: ${(props) =>
      (props.isSelector || props.isMobile) &&
      (props.selected
        ? `1px solid ${CONFIG.COLOR_PRIMARY}`
        : `1px solid ${border}`)};
    > div {
      background: ${(props) => props.background};
    }
  }
  > .slick-dots li button {
    background-color: ${(props) => props.dotColor};
  }
  > .slick-dots li.slick-active button {
    background-color: ${(props) => props.dotColor};
  }
`;

const PlanSelector = ({
  onChange,
  selected,
  planes,
  hover,
  disabled,
  multiple,
  mostrarTipo,
  mantenerExcluidos,
  tituloAdicional,
  opcionesDePago,
  subcoberturasParaExcluir,
  controlFranquicias,
  alertaParaEjecutivo,
  moneda,
  infoMoneda,
  readonly,
  mostrarLandingPorDefecto,
  landingPorDefectoIndex,
  landingPorDefectoAuxIndex
}) => {
  const isSelector = onChange;
  const planSelected = selected >= 0 ? selected : selected || [];
  const isSelected =
    (multiple && planSelected.length > 0) ||
    (!multiple && selected !== undefined && selected !== false);
  const [hoveredIndex, setHoveredIndex] = useState();
  const { producto } = useContext(EmpresaContext);
  const { user, userState } = useContext(UserContext);
  const [mobileActive, setMobileActive] = useState(0);
  const carouselRef = useRef({});
  const screens = useBreakpoint();

  const planesPrincipales = planes?.map((item) => item.principal) || [];
  const planesSecundarios = planes?.map((item) => item.secundario) || [];
  const planesConWarning = planes?.map((item) => item.warning) || [];

  const normalizar = (data) => {
    if (alertaParaEjecutivo) {
      if (
        (user && user['cognito:groups'][0] === 'CLIENTE') ||
        (!user &&
          (userState === USER_STATES.loggingEnd ||
            userState === USER_STATES.notLogged))
      ) {
        return data.filter((e) => !e.exclusion);
      }

      const newData = [];
      for (let i = 0; i < data.length; i += 1) {
        const d = data[i];
        if (d.exclusion) {
          d.sumas = d.sumas.map(() => 'Excluye');
          d.items = d.items.map(() => 'Excluye');
        }
        newData.push(d);
      }
      return newData;
    }
    return data.filter((e) => !e.exclusion);
  };

  const data = normalizar(
    getTable(
      planes,
      null,
      null,
      producto,
      mostrarTipo,
      mantenerExcluidos,
      tituloAdicional,
      false,
      moneda,
      subcoberturasParaExcluir,
      controlFranquicias
    )
  );

  const isPlanSelected = (plan) => {
    if (multiple) {
      return isSelected && planSelected && planSelected.includes(plan);
    }
    return isSelected && plan === planSelected;
  };
  const isPrincipalPlan = (columnIndex) => planesPrincipales[columnIndex];
  const isSecondaryPlan = (columnIndex) => planesSecundarios[columnIndex];
  const isWarningPlan = (columnIndex) => planesConWarning[columnIndex];

  const disabledOrSecondary = (isDisabled, isSecondary) => {
    if (isDisabled) {
      return {
        color: 'gray',
        backgroundColor: 'lightgrey'
      };
    }
    if (isSecondary) {
      return {
        // color: 'gray',
        backgroundColor: backgroundColor()
        //  background: 'rgb(0,0,0, 0.05)'
      };
    }
    return {};
  };

  const disabledOrSecondaryHeader = (isDisabled, isSecondary) => {
    if (isDisabled) {
      return {
        color: 'gray',
        backgroundColor: 'lightgrey'
      };
    }
    if (isSecondary) {
      return {
        color: '',
        backgroundColor: backgroundColor()
        //  background: 'rgb(0,0,0, 0.05)'
      };
    }
    return {};
  };

  // const widthMobile = mostrarCobDetalle ? '100px' : '80px';
  const widthMobile = '80px';
  const styles = {
    fontSize: screens.md === false ? 11 : 14,
    paddingLeft: screens.md === false ? 4 : 8,
    paddingRight: screens.md === false ? 4 : 8,
    paddingTop: screens.md === false ? 2 : 4,
    paddingBottom: screens.md === false ? 2 : 4
  };
  const width =
    screens && screens.md === false
      ? { minWidth: widthMobile, maxWidth: widthMobile }
      : { minWidth: '250px', maxWidth: '500px' };

  const Header = styled.div`
    font-weight: bold;
    min-width: ${() => width.minWidth || '250px'};
    max-width: ${() => width.maxWidth || '500px'};
    display: inline-block;
    float: left;
    clear: both;
    width: max-content;
  `;

  const Detalle = styled.div`
    min-width: ${() => width.minWidth || '250px'};
    max-width: ${() => width.maxWidth || '500px'};
    display: inline-block;
    float: left;
    clear: both;
    width: max-content;
  `;

  const GroupHeader = styled.div`
    font-weight: bold;
    min-width: ${() => width.minWidth || '250px'};
    max-width: ${() => width.maxWidth || '500px'};
    display: inline-block;
    float: left;
    clear: both;
    width: max-content;
  `;

  const Footer = styled.div`
    min-width: ${() => width.minWidth || '250px'};
    max-width: ${() => width.maxWidth || '500px'};
    display: inline-block;
    float: left;
    clear: both;
    width: max-content;
  `;
  /*
  const Col = styled(ColAnt)`
    padding: 4px 10px;
  `;
*/
  const planTitleStyle = (dataSource, rowIndex, item) => {
    const cantFooters = dataSource.filter((element) => element.footer).length;
    // console.log('width: ', width);
    const style = {
      fontSize: styles.fontSize,
      paddingLeft: styles.paddingLeft,
      paddingRight: styles.paddingRight,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
      backgroundColor: !disabled ? 'white' : disabledBackgroundColor,
      color: disabled ? disabledTextColor : '',
      textAlign: 'left'
    };

    if (rowIndex === 0) {
      return {
        ...style,
        backgroundColor: !disabled
          ? backgroundColor()
          : disabledBackgroundColorHeader(),
        color: !disabled ? '' : disabledTextColor,
        borderBottom: `1px solid ${border}`,
        borderRight: !disabled ? `1px solid ${borderHeader()}` : 'gray',
        ...disabledOrSecondaryHeader(disabled)
      };
    }
    if (rowIndex > 0 && !item.footer) {
      if (rowIndex < dataSource.length - cantFooters - 1) {
        style.borderBottom = `1px solid ${border}`;
      }
      return {
        ...style,
        fontWeight: 'normal',
        borderRight: `1px solid ${border}`
      };
    }
    if (item.footer) {
      return {
        ...style,
        borderTop: `1px solid ${border}`,
        borderRight: `1px solid ${border}`,
        backgroundColor: backgroundColor()
      };
    }
    return {};
  };
  const planTitleStyleMobile = (dataSource, rowIndex) => {
    const cantFooters = dataSource.filter((element) => element.footer).length;
    const style = {
      fontSize: styles.fontSize,
      paddingLeft: styles.paddingLeft,
      paddingRight: styles.paddingRight,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
      textAlign: 'left',
      background: !disabled ? 'white' : disabledBackgroundColor,
      color: disabled ? disabledTextColor : ''
    };
    if (
      rowIndex === 0 ||
      rowIndex > dataSource.length - cantFooters - 1 ||
      dataSource[rowIndex].footer
    ) {
      style.fontWeight = 'bold';
      style.background = !disabled
        ? backgroundColorMobile
        : disabledBackgroundColor;
    }
    if (rowIndex < dataSource.length) {
      style.borderBottom = `1px solid ${border}`;
    }
    if (rowIndex === dataSource.length - cantFooters - 1 || rowIndex === 0) {
      style.borderBottom = `1px solid ${border}`;
    }
    if (rowIndex === dataSource.length - 1) {
      style.borderBottom = `1px solid ${backgroundColorMobile}`;
    }
    if (rowIndex === 0 && isPlanSelected(mobileActive)) {
      style.color = !disabled ? '' : disabledBackgroundColor;
      style.background = !disabled
        ? backgroundColor()
        : disabledBackgroundColor;
    }
    return style;
  };

  const planStyleMobile = (dataSource, rowIndex) => {
    const cantFooters = dataSource.filter((element) => element.footer).length;
    const cantOptions = dataSource.filter((element) => element.opcion).length;

    const style = {
      textAlign: 'right',
      cursor: 'pointer',
      fontSize: styles.fontSize,
      paddingLeft: styles.paddingLeft,
      paddingRight: styles.paddingRight,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
      whiteSpace: 'nowrap',
      justifyContent: 'flex-end',
      alignItems: 'center',
      backgroundColor: !disabled
        ? backgroundColorMobile
        : disabledBackgroundColor,
      color: disabled ? disabledTextColor : ''
    };
    // El primer elemento o los footers
    if (rowIndex === 0) {
      style.backgroundColor = !disabled
        ? backgroundColorMobile
        : disabledBackgroundColor;
    }
    if (rowIndex > 0 && rowIndex < dataSource.length - cantOptions) {
      style.backgroundColor = !disabled ? 'white' : disabledBackgroundColor;
    }

    if (rowIndex < dataSource.length - 1) {
      style.borderBottom = `1px solid ${border}`;
    }
    // if (rowIndex > 0 && rowIndex < dataSource.length - cantFooters) {
    //   style.background = !disabled ? 'white' : disabledBackgroundColor;
    // }
    if (rowIndex === dataSource.length - cantFooters - 1 || rowIndex === 0) {
      style.borderBottom = `1px solid ${border}`;
    }
    if (rowIndex === dataSource.length - 1) {
      style.borderBottom = `1px solid ${backgroundColorMobile}`;
    }
    if (
      dataSource[rowIndex].franquicia ||
      dataSource[rowIndex].franquicia_general
    ) {
      style.whiteSpace = 'normal';
    }
    if (rowIndex === 0 && isPlanSelected(mobileActive)) {
      style.color = !disabled ? '' : disabledBackgroundColor;
      style.backgroundColor = !disabled
        ? backgroundColor()
        : disabledBackgroundColor;
    }
    return style;
  };

  const planStyle = (dataSource, columnIndex, rowIndex) => {
    const cantFooters = dataSource.filter((element) => element.footer).length;
    let style = {
      textAlign: 'right',
      cursor: !disabled && !readonly ? 'pointer' : 'default',
      fontSize: styles.fontSize,
      paddingLeft: styles.paddingLeft,
      paddingRight: styles.paddingRight,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
      whiteSpace: 'nowrap',
      justifyContent: 'flex-end',
      alignItems: 'center',
      maxWidth: 150,
      minWidth: 150,
      backgroundColor: !disabled ? '' : disabledBackgroundColor,
      color: disabled ? disabledTextColor : ''
    };
    const esEncabezadoOFooter =
      rowIndex === 0 || rowIndex > data.length - cantFooters - 1;
    if (esEncabezadoOFooter) {
      style.backgroundColor = !disabled
        ? backgroundColor()
        : disabledBackgroundColorHeader();
      style.color = !disabled ? '' : disabledTextColor;
      style = {
        ...style,
        ...disabledOrSecondaryHeader(disabled, isSecondaryPlan(columnIndex))
      };
    }

    if (hoveredIndex < 0) {
      return style;
    }

    if (columnIndex === hoveredIndex) {
      style.color = 'white';
      style.backgroundColor = `rgb(${hexToRgb(CONFIG.COLOR_PRIMARY)}, 0.75)`;
    } else if (!esEncabezadoOFooter) {
      style.backgroundColor = !disabled ? '' : disabledBackgroundColor;
    }

    if (columnIndex === planSelected && isSelected) {
      style.color = 'white';
      style.backgroundColor = CONFIG.COLOR_PRIMARY;
    }

    if (rowIndex < dataSource.length - cantFooters - 1) {
      style.borderBottom = `1px solid ${border}`;
    }
    if (rowIndex < dataSource.length) {
      style.borderLeft = `1px solid ${border}`;
    }

    if (rowIndex === 0) {
      style.fontWeight = 'bold';
    }
    if (dataSource[rowIndex].footer) {
      style.fontWeight = 'bold';
    }

    if (
      dataSource[rowIndex].franquicia ||
      dataSource[rowIndex].franquicia_general
    ) {
      style.whiteSpace = 'normal';
    }

    if (rowIndex > dataSource.length - cantFooters - 1) {
      style.fontWeight = 'bold';
      style.borderTop = `1px solid ${border}`;
    }
    return style;
  };

  const planStyleMultiple = (dataSource, columnIndex, rowIndex) => {
    const cantFooters = dataSource.filter((element) => element.footer).length;
    let style = {
      fontSize: styles.fontSize,
      paddingLeft: styles.paddingLeft,
      paddingRight: styles.paddingRight,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
      textAlign: 'right',
      cursor: !disabled && !readonly ? 'pointer' : 'default',
      whiteSpace: 'nowrap',
      justifyContent: 'flex-end',
      alignItems: 'center',
      maxWidth: 150,
      minWidth: 150,
      backgroundColor: !disabled ? 'white' : disabledBackgroundColor
    };
    const esEncabezadoOFooter =
      rowIndex === 0 || rowIndex > data.length - cantFooters - 1;
    if (esEncabezadoOFooter) {
      style.backgroundColor = !disabled
        ? backgroundColor()
        : disabledBackgroundColorHeader();
      style.color = '';
      style = {
        ...style,
        ...disabledOrSecondaryHeader(disabled, isSecondaryPlan(columnIndex))
      };
    } else {
      style = {
        ...style,
        ...disabledOrSecondary(disabled, isSecondaryPlan(columnIndex))
      };
    }

    if (hoveredIndex < 0) {
      return style;
    }

    if (columnIndex === hoveredIndex) {
      style.color = 'white';
      style.backgroundColor = `rgb(${hexToRgb(CONFIG.COLOR_PRIMARY)}, 0.75)`;
    } else if (!esEncabezadoOFooter) {
      style.backgroundColor = !disabled ? 'white' : disabledBackgroundColor;
    }

    const changeColor = planSelected.find((item) => item === columnIndex);
    if ((changeColor || changeColor === 0) && isSelected) {
      style.color = 'white';
      style.backgroundColor = CONFIG.COLOR_PRIMARY;
    }

    if (rowIndex < data.length - cantFooters - 1) {
      style.borderBottom = `1px solid ${border}`;
    }
    if (rowIndex < data.length) {
      style.borderLeft = `1px solid ${border}`;
    }

    if (rowIndex === 0) {
      style.fontWeight = 'bold';
    }

    if (rowIndex > data.length - cantFooters - 1) {
      style.fontWeight = 'bold';
      style.borderTop = `1px solid ${border}`;
    }
    if (
      dataSource[rowIndex]?.franquicia ||
      dataSource[rowIndex]?.franquicia_general
    ) {
      style.whiteSpace = 'normal';
    }
    return style;
  };

  const contentStyle = {
    textAlign: 'left',
    marginTop: 20
  };

  const buttonsStyle = {
    noPadding: { padding: 0 },
    noRadius: { borderRadius: 0 }
  };

  const dataOpcionesPago = getTableOpcionesPago(
    planes,
    null,
    opcionesDePago,
    moneda,
    infoMoneda
  );

  useLayoutEffect(() => {
    setTimeout(() => addScrollShadows(), 500);
  }, []);

  const PlanIndicator = ({ index }) => {
    if (!isPrincipalPlan(index) && !isWarningPlan(index)) {
      return null;
    }
    const config = {
      icon: undefined,
      tooltip: undefined,
      type: undefined
    };

    if (isPrincipalPlan(index)) {
      config.icon = <StarFilled style={{ color: yellow.primary }} />;
      config.tooltip = 'Plan recomendado';
    }
    if (isWarningPlan(index)) {
      config.icon = <InfoCircleOutlined />;
      config.tooltip = 'Sujeto a aprobación del área técnica';
      config.type = 'warning';
    }
    return (
      <Tooltip title={config.tooltip}>
        <Typography.Text type={config.type}>{config.icon}</Typography.Text>
      </Tooltip>
    );
  };

  const carouselData = getCarouselData([
    ...data,
    ...(opcionesDePago
      ? getTableOpcionesPago(
          planes,
          true,
          opcionesDePago,
          moneda,
          infoMoneda
        ).map((item) => ({
          ...item,
          footer: true
        }))
      : [])
  ]);

  const getMontoFinal = (suma) => {
    if (suma === -3 || suma === '-3') {
      return '100%';
    }
    return Number(suma) ? formatoMonedaGenerico(moneda, suma) : suma || '100%';
  };

  const getMontoMobile = (inner) => {
    if ((inner.franquicia || inner.franquicia_general) && !inner.suma) {
      return 'N/A';
    }
    if (Number(inner.suma)) {
      return formatoMonedaGenerico(moneda, inner.suma);
    }
    return inner.suma;
  };

  let backgroundColorFinal;

  if (disabled) {
    backgroundColorFinal = disabledBackgroundColor;
  } else if (isPlanSelected(mobileActive)) {
    backgroundColorFinal = backgroundColor();
  } else {
    backgroundColorFinal = backgroundColorMobile;
  }

  const getControles = (item) => {
    if (item.reemplazo) {
      return (
        <Space>
          {item.detalle}
          {alertaParaEjecutivo && (
            <Tooltip
              title={
                <div>
                  Subcobertura reemplazada:{' '}
                  {item.anterior.cobertura.descripcion}
                </div>
              }
            >
              <ExclamationCircleOutlined
                style={{
                  color: 'orange'
                }}
              />
            </Tooltip>
          )}
        </Space>
      );
    }
    if (item.exclusion) {
      return (
        <Space style={{ textDecoration: 'line-through' }}>
          {item.detalle}{' '}
          <Tooltip title="Esta cobertura será excluída">
            <ExclamationCircleOutlined
              style={{
                color: 'red'
              }}
            />
          </Tooltip>
        </Space>
      );
    }

    if (item.incluye && item.franquicia_general && alertaParaEjecutivo) {
      return (
        <Tooltip title="Esta franquicia será incluida">
          {' '}
          <Space>
            {item.detalle}
            <ExclamationCircleOutlined
              style={{
                color: 'orange'
              }}
            />
          </Space>
        </Tooltip>
      );
    }
    return item.detalle;
  };

  return (
    <>
      {screens.md === true && planes.length > 0 && (
        <>
          <Container
            selected={isSelected}
            style={{ margin: 'auto', display: 'grid' }}
            hover={hover}
            isSelector={isSelector}
            className="table-wrapper"
          >
            <div className="table-shadow shadow-left" />
            <div className="table-inner-wrapper">
              <table
                id="table1"
                style={{
                  textAlign: 'start',
                  width: '100%',
                  borderRadius: 6
                }}
                className="table"
              >
                {opcionesDePago && (
                  <>
                    <tbody>
                      {dataOpcionesPago.map((item, rowIndex) => (
                        <tr key={rowIndex}>
                          {rowIndex === 0 && (
                            <td
                              style={planTitleStyle(
                                dataOpcionesPago,
                                rowIndex,
                                item
                              )}
                              className="sticky-header"
                            >
                              <Header>{item.detalle}</Header>
                            </td>
                          )}

                          {rowIndex > 0 && (
                            <td
                              style={{
                                ...planTitleStyle(
                                  dataOpcionesPago,
                                  rowIndex,
                                  item
                                ),
                                borderBottom: `1px solid ${border}`
                              }}
                              className="sticky-column"
                            >
                              <Detalle>{item.detalle}</Detalle>
                            </td>
                          )}

                          {item.sumas.map((suma, columnIndex) => {
                            return (
                              <td
                                key={columnIndex}
                                style={{
                                  ...(multiple
                                    ? planStyleMultiple(
                                        dataOpcionesPago,
                                        columnIndex,
                                        rowIndex
                                      )
                                    : planStyle(
                                        dataOpcionesPago,
                                        columnIndex,
                                        rowIndex
                                      )),
                                  borderBottom: `1px solid ${border}`
                                }}
                                onMouseOver={() => {
                                  if (hover) {
                                    setHoveredIndex(columnIndex);
                                  }
                                }}
                                onMouseLeave={() => {
                                  if (hover) {
                                    setHoveredIndex(undefined);
                                  }
                                }}
                                onClick={() => {
                                  if (!disabled)
                                    if (onChange) {
                                      onChange(columnIndex);
                                    }
                                }}
                              >
                                <Space>
                                  {rowIndex === 0 ? (
                                    <div style={{ whiteSpace: 'normal' }}>
                                      {!suma ? `Plan ${columnIndex + 1}` : suma}
                                    </div>
                                  ) : (
                                    suma
                                  )}
                                  {rowIndex === 0 && (
                                    <PlanIndicator index={columnIndex} />
                                  )}
                                </Space>
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </>
                )}

                <tbody>
                  {data.map((item, rowIndex) =>
                    item.full ? (
                      <Fragment key={rowIndex}>
                        {item.detalle && item.detalle.trim() ? (
                          <tr key={rowIndex}>
                            <td
                              // colSpan={item.sumas.length + 1}
                              style={{
                                ...planTitleStyle(data, rowIndex, item),
                                borderRight: `1px solid ${border}`
                              }}
                              className="sticky-header"
                            >
                              <GroupHeader>{item.detalle}</GroupHeader>
                            </td>
                            {item.sumas.map((_, columnIndex) => (
                              <td
                                key={`${columnIndex}colgrupo`}
                                style={
                                  multiple
                                    ? planStyleMultiple(
                                        data,
                                        columnIndex,
                                        rowIndex
                                      )
                                    : planStyle(data, columnIndex, rowIndex)
                                }
                                onMouseOver={() => {
                                  if (hover) {
                                    setHoveredIndex(columnIndex);
                                  }
                                }}
                                onMouseLeave={() => {
                                  if (hover) {
                                    setHoveredIndex(undefined);
                                  }
                                }}
                                onClick={() => {
                                  if (!disabled)
                                    if (onChange) {
                                      onChange(columnIndex);
                                    }
                                }}
                              />
                            ))}
                          </tr>
                        ) : null}
                      </Fragment>
                    ) : (
                      <tr key={rowIndex}>
                        {rowIndex === 0 && (
                          <td
                            style={planTitleStyle(data, rowIndex, item)}
                            className="sticky-header"
                          >
                            <Header>{item.detalle}</Header>
                          </td>
                        )}

                        {rowIndex > 0 &&
                          rowIndex < data.length - 1 &&
                          !item.footer && (
                            <td
                              style={planTitleStyle(data, rowIndex, item)}
                              className="sticky-column"
                            >
                              <Detalle>{getControles(item)}</Detalle>
                            </td>
                          )}

                        {(rowIndex === data.length - 1 || item.footer) && (
                          <td
                            style={planTitleStyle(data, rowIndex, item)}
                            className="sticky-header"
                          >
                            <Footer> {getControles(item)}</Footer>
                          </td>
                        )}

                        {item.sumas.map((suma, columnIndex) => {
                          return (
                            <td
                              key={columnIndex}
                              style={
                                multiple
                                  ? planStyleMultiple(
                                      data,
                                      columnIndex,
                                      rowIndex
                                    )
                                  : planStyle(data, columnIndex, rowIndex)
                              }
                              onMouseOver={() => {
                                if (hover) {
                                  setHoveredIndex(columnIndex);
                                }
                              }}
                              onMouseLeave={() => {
                                if (hover) {
                                  setHoveredIndex(undefined);
                                }
                              }}
                              onClick={() => {
                                if (!disabled)
                                  if (onChange) {
                                    onChange(columnIndex);
                                  }
                              }}
                            >
                              {rowIndex !== 0 && getMontoFinal(suma)}
                              <Space>
                                {rowIndex === 0 && !opcionesDePago && (
                                  <div style={{ whiteSpace: 'normal' }}>
                                    {!suma ? `Plan ${columnIndex + 1}` : suma}
                                  </div>
                                )}
                                {rowIndex === 0 && !opcionesDePago && (
                                  <PlanIndicator index={columnIndex} />
                                )}
                              </Space>
                            </td>
                          );
                        })}
                      </tr>
                    )
                  )}
                  {isSelector && !disabled && (
                    <tr>
                      <td
                        className="sticky-header"
                        style={{
                          borderRight: `1px solid ${border}`
                        }}
                      />
                      {data[0].sumas.map((suma, columnIndex) => {
                        return (
                          <td
                            key={columnIndex}
                            style={{
                              ...(multiple
                                ? planStyleMultiple(
                                    dataOpcionesPago,
                                    columnIndex,
                                    1
                                  )
                                : planStyle(dataOpcionesPago, columnIndex, 1)),
                              borderBottom: `none`
                            }}
                            onMouseOver={() => {
                              if (hover) {
                                setHoveredIndex(columnIndex);
                              }
                            }}
                            onMouseLeave={() => {
                              if (hover) {
                                setHoveredIndex(undefined);
                              }
                            }}
                          >
                            <Row
                              justify="space-between"
                              style={buttonsStyle.noPadding}
                            >
                              <Col span={24} style={{ paddingLeft: 0 }}>
                                <Button
                                  type="default"
                                  style={{
                                    width: 130,
                                    paddingLeft: 8,
                                    paddingRight: 4
                                  }}
                                  ghost={isPlanSelected(columnIndex)}
                                  onClick={() => {
                                    if (!disabled)
                                      if (onChange) {
                                        onChange(columnIndex);
                                      }
                                  }}
                                >
                                  {!isPlanSelected(columnIndex) ? (
                                    <>
                                      <Radio style={{ margin: 0, padding: 0 }}>
                                        Seleccionar
                                      </Radio>
                                    </>
                                  ) : (
                                    <>
                                      <CheckCircleFilled />
                                      <span style={{ padding: 8 }}>
                                        Seleccionado
                                      </span>
                                    </>
                                  )}
                                </Button>
                              </Col>
                            </Row>
                            {mostrarLandingPorDefecto && (
                              <>
                                <br />
                                <Row
                                  justify="space-between"
                                  style={buttonsStyle.noPadding}
                                >
                                  <Col span={24} style={{ paddingLeft: 0 }}>
                                    <Button
                                      type="default"
                                      style={{
                                        width: 130,
                                        paddingLeft: 8,
                                        paddingRight: 4,
                                        textAlign: 'start'
                                      }}
                                      // ghost={isPlanSelected(columnIndex)}
                                      onClick={() => {
                                        if (!disabled)
                                          if (onChange) {
                                            onChange(columnIndex, true);
                                          }
                                      }}
                                    >
                                      {landingPorDefectoIndex !==
                                      columnIndex ? (
                                        <>
                                          <Radio
                                            style={{ margin: 0, padding: 0 }}
                                          >
                                            Landing
                                          </Radio>
                                        </>
                                      ) : (
                                        <>
                                          <CheckCircleFilled />
                                          <span style={{ padding: 8 }}>
                                            Landing
                                          </span>
                                        </>
                                      )}
                                    </Button>
                                  </Col>
                                </Row>
                                <br />
                                <Row
                                  justify="space-between"
                                  style={buttonsStyle.noPadding}
                                >
                                  <Col span={24} style={{ paddingLeft: 0 }}>
                                    <Button
                                      type="default"
                                      style={{
                                        width: 130,
                                        paddingLeft: 8,
                                        paddingRight: 4,
                                        textAlign: 'start'
                                      }}
                                      // ghost={isPlanSelected(columnIndex)}
                                      onClick={() => {
                                        if (!disabled)
                                          if (onChange) {
                                            const isAux = true;
                                            onChange(columnIndex, true, isAux);
                                          }
                                      }}
                                    >
                                      {landingPorDefectoAuxIndex !==
                                      columnIndex ? (
                                        <>
                                          <Radio
                                            style={{ margin: 0, padding: 0 }}
                                          >
                                            Landing Aux
                                          </Radio>
                                        </>
                                      ) : (
                                        <>
                                          <CheckCircleFilled />
                                          <span style={{ padding: 8 }}>
                                            Landing Aux
                                          </span>
                                        </>
                                      )}
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="table-shadow shadow-right" />
          </Container>
        </>
      )}
      {screens.md === false && planes.length > 0 && (
        <>
          <Container
            isMobile
            selected={isSelected}
            style={{
              overflowY: 'hidden',
              height: '100%'
            }}
          >
            <div>
              <CustomCarousel
                isMobile
                selected={isSelected}
                afterChange={(active) => {
                  setMobileActive(active);
                  // if (isSelected && onChange) {
                  //   onChange(active);
                  // }
                }}
                // initialSlide={planSelected}
                background={backgroundColorFinal}
                // className={isPlanSelected(mobileActive) && 'carousel-selected'}
                style={{
                  // backgroundColor: backgroundColorFinal,
                  margin: 'auto'
                }}
                dotPosition="top"
                dotColor={
                  isPlanSelected(mobileActive) ? 'white' : backgroundColor()
                }
                ref={carouselRef}
              >
                {carouselData.map((item, rowIndex) => (
                  <div key={rowIndex}>
                    <table
                      style={{
                        ...contentStyle,
                        marginTop:
                          carouselData.length === 1
                            ? 0
                            : contentStyle.marginTop,
                        overflowX: 'auto',
                        width: '100%'
                      }}
                    >
                      <tbody>
                        {item.map(
                          (inner, rowIndexParam) =>
                            ((inner.full &&
                              inner.detalle &&
                              inner.detalle.trim()) ||
                              !inner.full) && (
                              <tr key={rowIndexParam}>
                                <td
                                  colSpan={inner.full ? 2 : 1}
                                  style={{
                                    ...planTitleStyleMobile(
                                      item,
                                      rowIndexParam
                                    ),
                                    ...(inner.opcion
                                      ? { fontWeight: 'bold' }
                                      : {}),
                                    ...(inner.full
                                      ? {
                                          fontWeight: 'bold',
                                          paddingTop: 8
                                        }
                                      : {})
                                  }}
                                >
                                  {inner.detalle}
                                </td>
                                {!inner.full && (
                                  <td
                                    xs={8}
                                    width="1px"
                                    style={{
                                      ...planStyleMobile(item, rowIndexParam),
                                      fontWeight:
                                        inner.opcion || rowIndexParam === 0
                                          ? 'bold'
                                          : 'normal',
                                      ...(rowIndexParam === 0
                                        ? { whiteSpace: 'normal' }
                                        : {})
                                    }}
                                  >
                                    <Space>
                                      {rowIndexParam === 0 && !inner.suma
                                        ? `Plan ${rowIndex + 1}`
                                        : getMontoMobile(inner)}
                                      {rowIndexParam === 0 && (
                                        <PlanIndicator index={rowIndex} />
                                      )}
                                    </Space>
                                  </td>
                                )}
                              </tr>
                            )
                        )}
                      </tbody>
                    </table>
                  </div>
                ))}
              </CustomCarousel>
            </div>
            {carouselData.length > 0 && isSelector && !disabled && (
              <>
                <Row justify="space-between" style={buttonsStyle.noPadding}>
                  <Col span={24} style={{ paddingLeft: 0 }}>
                    <Button
                      block
                      type={isPlanSelected(mobileActive) ? 'primary' : 'text'}
                      // ghost={!(isSelected && planSelected.includes(mobileActive))}
                      style={buttonsStyle.noRadius}
                      onClick={() => {
                        if (!disabled)
                          if (onChange) {
                            onChange(mobileActive);
                          }
                      }}
                    >
                      {!isPlanSelected(mobileActive) ? (
                        <>
                          <Radio style={{ margin: 0, padding: 0 }}>
                            Seleccionar
                          </Radio>
                        </>
                      ) : (
                        <>
                          <CheckCircleFilled />
                          <span style={{ padding: 8 }}>Seleccionado</span>
                        </>
                      )}
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Container>

          {carouselData.length > 1 && (
            <Row
              justify="center"
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 8,
                paddingBottom: 8
              }}
            >
              <Col span={12} style={{ padding: 0 }}>
                <Button
                  block
                  type="link"
                  style={buttonsStyle.noRadius}
                  onClick={() => carouselRef.current.prev()}
                >
                  <LeftOutlined />
                  Anterior
                </Button>
              </Col>
              <Col span={12} style={buttonsStyle.noPadding}>
                <Button
                  block
                  type="link"
                  style={buttonsStyle.noRadius}
                  onClick={() => carouselRef.current.next()}
                >
                  Siguiente
                  <RightOutlined />
                </Button>
              </Col>
            </Row>
          )}
        </>
      )}
    </>
  );
};

export default PlanSelector;
